import React from 'react'
import {useController} from 'react-hook-form'
import NumberFormat from 'react-number-format'
import {INPUT_NAMES, usePageContext} from 'Src/components/pages/SoftPull/PageContext'
import {useFrameContext} from 'Src/contexts/FrameContext'
import {useRegistrationContext} from 'Src/contexts/RegistrationContext'
import {trans} from 'Src/utilities/Helpers'

const ZipCode = () => {
  const inputName = INPUT_NAMES.ZIP_CODE
  const {
    dealership: {
      attributes: {zip_code: dealershipZip},
    },
  } = useFrameContext()
  const {control} = usePageContext()
  const {
    field,
    fieldState: {error},
  } = useController({
    control,
    name: inputName,
  })
  const {
    registrationState: {cityListLoadingError},
  } = useRegistrationContext()
  const errorMessage = error?.message ? error?.message : cityListLoadingError || ''

  return (
    <div className="md:tw-w-2/12" aria-live="assertive" aria-atomic="false">
      <label htmlFor={inputName} className="required input-label tw-mb-2">
        {trans('zip')}
      </label>
      <NumberFormat
        type="text"
        id={inputName}
        placeholder={dealershipZip}
        className="input-field tw-w-full md:tw-placeholder-transparent"
        allowLeadingZeros
        allowNegative={false}
        maxLength={5}
        inputMode="numeric"
        autoComplete="postal-code"
        required
        aria-required="true"
        {...field}
      />
      {errorMessage ? (
        <div>
          <span className="error">{errorMessage}</span>
        </div>
      ) : null}
    </div>
  )
}

export default ZipCode
